import { useCurrentLang } from './useCurrentLang';

export const useIsRtl = () => {
  return useCurrentLang() === 'ar';
};
